import { useQuery } from "@tanstack/react-query";
import { callApi } from "../utils/ApiCallPostOnly";

export const useStaffCardContractList = () => {
  const filter = {
    filter: { f_Id: "", f_selectedType: "Active" },
  };

  return useQuery({
    queryKey: ["staffCardContractListState"],
    queryFn: async () =>
      callApi({
        path: "contractlist",
        command: "",
        data: JSON.stringify({ list: filter }),
      }),
  });
};
